var _defs, _text, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "INFORM",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #INFORM .cls-1, #INFORM .cls-2 {\n        fill: #00c4ff;\n      }\n\n      #INFORM .cls-1 {\n        font-size: 16px;\n        font-family: Swiss721BT-BoldCondensed, Swis721 Cn BT;\n        font-weight: 700;\n        letter-spacing: 0.05em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "i",
    className: "cls-1",
    transform: "translate(9.5 17.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_347",
    "data-name": "Pfad 347",
    className: "cls-2",
    d: "M12,0A12,12,0,1,0,24,12,11.987,11.987,0,0,0,12,0Zm0,22.5A10.5,10.5,0,1,1,22.5,12,10.629,10.629,0,0,1,12,22.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInform);
export default __webpack_public_path__ + "static/media/inform.03c1c98fad6e3ed8ec5436ac0726262e.svg";
export { ForwardRef as ReactComponent };